import React, { useEffect, useState } from "react";
import FormHelperText from "components/Form/components/FormHelperText";
import { useFormContext } from "react-hook-form";
import _ from "lodash";
import PropTypes from "prop-types";
import FormSubtext from "./FormSubtext";
import Options from "./Options";

const Select = ({
  classes,
  defaultValue,
  error,
  id,
  label,
  name,
  options,
  register,
  defaultOption,
  dataTestId,
  ...selectProps
}) => {
  const [loading, setLoading] = useState(true);
  const [mappedOptions, setMappedOptions] = useState();
  const { setValue, watch } = useFormContext();
  const selected = watch(name);

  useEffect(() => {
    setValue && !selected && setValue(name, selectProps.defaultValue);
  }, [name, selectProps.defaultValue, setValue, selected]);

  const processedOptions = Options({ options });

  useEffect(() => {
    if (_.isArray(processedOptions) && loading) {
      setMappedOptions(processedOptions);
      setLoading(false);
    }
  }, [processedOptions, loading]);

  const updateSelect = (e) => {
    setValue(name, e.target.value);
  };

  const defaultOptionElement = defaultOption ? (
    <option value={defaultOption.value}>{defaultOption.label}</option>
  ) : null;

  return (
    <>
      <label htmlFor={id ?? name}>{label}</label>
      {selectProps.subtext && <FormSubtext text={selectProps.subtext} />}
      <div className="select">
        {!loading && (
          <select
            onChange={updateSelect}
            {...register(name)}
            className={`input-select ${classes ?? ""}`}
            id={id ?? name}
            defaultValue={defaultValue}
            data-testid={dataTestId}
          >
            {!defaultValue && defaultOptionElement}
            {mappedOptions}
            {selectProps.children}
          </select>
        )}
      </div>
      {error && <FormHelperText message={error.message} />}
    </>
  );
};

Select.propTypes = {
  // common
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  subtext: PropTypes.string,
  register: PropTypes.func.isRequired,
  error: PropTypes.shape({ message: PropTypes.string }),

  // specific
  defaultValue: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.element,
  options: PropTypes.any,
};

export default Select;
